

exports.__esModule = true;
exports.$CardMetaData = undefined;

var _LIBRARY_TO_TYPE_MAP;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _creditCardType = require('credit-card-type');

var _creditCardType2 = _interopRequireDefault(_creditCardType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_TYPE = {
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16],
    niceType: 'Unknown',
    patterns: [],
    type: 'DEFAULT'
};

// Add additional supported card types
// TODO: Provide patterns for these types
_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    niceType: 'Carte Bancaire',
    patterns: [],
    type: 'cb-nationale'
});

_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12, 16],
    lengths: [19],
    niceType: 'Carte Aurore',
    patterns: [],
    type: 'cetelem'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8, 12, 16],
    lengths: [17],
    niceType: 'Cofinoga ou Privilège',
    patterns: [],
    type: 'cofinoga'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8],
    lengths: [8, 9],
    niceType: '4 étoiles',
    patterns: [],
    type: 'cofidis'
});

var LIBRARY_TO_TYPE_MAP = (_LIBRARY_TO_TYPE_MAP = {}, _LIBRARY_TO_TYPE_MAP[_creditCardType.types.AMERICAN_EXPRESS] = 'AMEX', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DINERS_CLUB] = 'DINERSCLUB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DISCOVER] = 'DISCOVER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.ELO] = 'ELO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPER] = 'HIPER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPERCARD] = 'HIPERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.JCB] = 'JCB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MASTERCARD] = 'MASTERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MAESTRO] = 'MAESTRO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.UNIONPAY] = 'CUP', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.VISA] = 'VISA', _LIBRARY_TO_TYPE_MAP['cb-nationale'] = 'CBNATIONALE', _LIBRARY_TO_TYPE_MAP.cetelem = 'CETELEM', _LIBRARY_TO_TYPE_MAP.cofidis = 'COFIDIS', _LIBRARY_TO_TYPE_MAP.cofinoga = 'COFINOGA', _LIBRARY_TO_TYPE_MAP);

// Invert LIBRARY_TO_TYPE_MAP to enable to opposite lookup in constant time
var TYPE_TO_LIBRARY_MAP = Object.entries(LIBRARY_TO_TYPE_MAP).reduce(function (inverted, pair) {
    inverted[pair[1]] = pair[0];
    return inverted;
}, {});

/**
 * Detect the card type of the passed partial or full card number.
 * Returns null (no match) if the detected card type is not in allowedTypes.
 * 
 * @param {Array} allowedTypes Array of allowed card types
 * @param {String} number Partial or full card number
 */
function detectCardType(allowedTypes, number) {
    var matches = (0, _creditCardType2['default'])(number);
    var metadata = _angular2['default'].isArray(matches) && matches[0];

    if (metadata) {
        var cardType = LIBRARY_TO_TYPE_MAP[metadata.type];

        if (allowedTypes.indexOf(cardType) > -1) {
            return cardType;
        }
    }

    return null;
}

/**
 * Determine the input fields to show for the passed cardType.
 * 
 * @param {String} cardType The card type (e.g. VISA, AMEX, or MASTERCARD)
 * @param {String} productType The card product type (e.g. 'DEBIT' or 'CREDIT')
 * @param {String} country The user's country code
 */
function getCardFields(cardType, productType, country) {
    var isDebit = ['DEBIT', 'DEBITCARD'].indexOf(productType) > -1;
    var isCupC2 = cardType === 'CUP' && country === 'C2';
    var isCupC2Debit = isCupC2 && isDebit;

    return {
        issue: cardType === 'SWITCH',
        expiry: ['PLCC', 'COFIDIS'].indexOf(cardType) === -1 && !isCupC2Debit,
        cvv: ['PLCC', 'COFIDIS', 'COFINOGA'].indexOf(cardType) === -1 && !isCupC2Debit,
        dob: ['CETELEM', 'COFIDIS', 'COFINOGA'].indexOf(cardType) > -1,
        phone: isCupC2,
        address: !(cardType === 'PLCC' || isCupC2)
    };
}

var $CardMetaData = exports.$CardMetaData = {
    /**
     * Get part of the card type metadata for a particular card.
     * 
     * This function is now essentially a shim between the old hardcoded
     * card metadata object and the credit-card-type library. Field lookups
     * could be more efficient, but this maintains the existing API.
     * 
     * @param {Object} card Card object
     * @param {String} field Requested field (e.g. 'luhn' or 'fields.cvv')
     * @param {String} country The user's country code
     */
    getMetaData: function getMetaData(card, field, country) {
        var tokens = field.split('.');
        var prop = tokens[0];
        var attr = tokens[1];

        if (prop === 'phoneType') {
            // This was always 'Mobile' in the old metadata object
            return 'Mobile';
        }

        // Some cards can run on two networks, e.g. Visa + UnionPay
        var cardType = card && card.type;
        var dualType = card && card.dualType;

        if (prop === 'luhn') {
            // Cofidis cards do not use the Luhn check
            return cardType !== 'COFIDIS';
        }

        if (prop === 'fields') {
            var cardFields = getCardFields(cardType, card.productType, country);

            // Return only the requested field
            return attr ? cardFields[attr] : cardFields;
        }

        // For dual-brand cards, the card number will conform to the cobranded
        // network's format instead of the UnionPay format
        var cardFormatType = dualType && dualType !== 'CUP' ? dualType : cardType;
        var mapped = TYPE_TO_LIBRARY_MAP[cardFormatType];
        var metadata = mapped ? (0, _creditCardType.getTypeInfo)(mapped) : DEFAULT_TYPE;

        if (prop === 'spaces') {
            return attr ? metadata.gaps[attr] : metadata.gaps;
        }

        if (prop === 'length') {
            var lengths = {
                cvv: metadata.code && metadata.code.size,
                min: Math.min.apply(null, metadata.lengths),
                max: Math.max.apply(null, metadata.lengths)
            };

            // Return only the requested field
            return attr ? lengths[attr] : lengths;
        }

        // Unknown field
        return null;
    },


    /**
     * Get the card type of the passed partial or full card number.
     * 
     * @param {Array} allowedTypes Array of allowed card types
     * @param {String} number Partial or full card number
     */
    getCardType: function getCardType(allowedTypes, number) {
        var cardType = {};

        if (_angular2['default'].isArray(allowedTypes) && number) {
            cardType.type = detectCardType(allowedTypes, number);
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js
// module id = ../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js
// module chunks = 0